/* eslint-disable dot-notation */ import {
  Box,
  Chip,
  CircularProgress,
  Grid,
  Paper,
  Stack,
  SvgIcon,
  Typography,
} from '@mui/material';
import { Formik, useFormikContext } from 'formik';
import {
  AppFormikSelect,
  AppFormikTextField,
  AppPrimaryButton,
  AppPrimaryButtonOutlined,
  ConfirmDialog,
} from 'shared/components/AppComponents';
import { ReactComponent as Search } from 'assets/images/ic_search.svg';
import { ReactComponent as DeleteQuiz } from 'assets/images/delete-item-training.svg';
import { ReactComponent as View } from 'assets/images/view-training.svg';
import { ReactComponent as Edit } from 'assets/images/edit-training.svg';
import { useNavigate } from 'react-router-dom';
import { getChipColorByIndex } from 'shared/helpers/RandomChipColor';
import { TrainingPorgramsService } from 'services/TrainingProgramService';
import { useState } from 'react';
import { Toast, Utils } from 'shared/helpers';
import { useSelector } from 'react-redux';
import { IAppState } from 'state/RootReducer';
import { BaseApplicationState } from 'state/baseapplication/Reducer';
import useSize from 'shared/components/Hooks';

interface TrainingProgramsProps {
  programs: any;
  trainingData: any;
  loadingData: boolean;
  handleUpdateList: () => void;
  handleStatusChange: (value: string) => void;
  debouncSearch: (value: string) => void;
  handleDomainChange: (value: string) => void;
  handleClearFilter: () => void;
}

const TrainingProgramListComponent = ({
  loadingData,
  trainingData,
  setDialogDelete,
  debouncSearch,
  handleStatusChange,
  handleDomainChange,
  handleClearFilter,
}: any): any => {
  const navigation = useNavigate();
  const { orgACLConfig }: BaseApplicationState = useSelector(
    (state: any) => state.baseAppState
  );
  const { resetForm }: any = useFormikContext();

  const { isMobile } = useSize();

  // const filteredData = useMemo(() => {
  //   if (!trainingData) return [];
  //   const search = (values['search-programs'] ?? '').toLowerCase();
  //   let status = values['status'] ?? '';
  //   status = status === 'All Status' ? '' : status;
  //   let domain = values['domains'] ?? '';
  //   domain = domain === 'All Domains' ? '' : domain;

  //   return trainingData.filter((data: any) => {
  //     const program = data.program_data;

  //     const matchesSearch =
  //       !search || program.title?.toLowerCase().includes(search);
  //     const matchesStatus =
  //       !status || program.status?.toLowerCase() === status.toLowerCase();
  //     const matchesDomain =
  //       !domain ||
  //       program.ai_rmf_domains?.some(
  //         (d: string) => d.toLowerCase() === domain.toLowerCase()
  //       );

  //     return matchesSearch && matchesStatus && matchesDomain;
  //   });
  // }, [trainingData, values]);

  return (
    <Stack className="training-program-content" direction="column" spacing={5}>
      <Grid container className="training-program-nav">
        <Grid item sm={4} xs={12}>
          <Box className="training-search">
            <AppFormikTextField
              inputProps={{
                startAdornment: (
                  <SvgIcon
                    component={Search}
                    inheritViewBox
                    className="view-icon"
                    fontSize="inherit"
                    htmlColor="#76A81F"
                  />
                ),
              }}
              outerLabel={false}
              placeholder="Search training program.."
              name="search-programs"
              onChange={(e: any) => {
                debouncSearch(e.target.value);
              }}
            />
          </Box>
        </Grid>
        <Grid item sm={8} xs={12} className="training-selection-wrapper">
          <Stack
            className="training-selection-nav"
            direction={isMobile ? 'column' : 'row'}
            spacing={2}
          >
            <AppFormikSelect
              name="status"
              className="rework-selection"
              notched={false}
              labelId="fix-selection-label"
              testid="solicitor-dropdown"
              MenuProps={{
                className: 'menu-fix-selection single-fix-rework',
              }}
              placeholder="Filter Status"
              notEmphasized
              notSelectablePlaceholder={false}
              items={['All Status', 'Published', 'Draft', 'Archived']}
              onChange={(e: any) => {
                handleStatusChange(e.target.value);
              }}
            />
            <AppFormikSelect
              name="domains"
              className="rework-selection"
              notched={false}
              labelId="fix-selection-label"
              testid="solicitor-dropdown"
              MenuProps={{
                className: 'menu-fix-selection single-fix-rework',
              }}
              placeholder="Filter Domain"
              notEmphasized
              notSelectablePlaceholder={false}
              items={[
                'All Domains',
                'Transparency',
                'Fairness',
                'Accountability',
                'Robustness',
                'Safety',
                'Privacy/Security',
              ]}
              onChange={(e: any) => {
                handleDomainChange(e.target.value);
              }}
            />
            <AppPrimaryButtonOutlined
              fullWidth
              title="Clear Filters"
              onClick={() => {
                resetForm();
                handleClearFilter();
              }}
              sx={{
                borderColor: '#e7e7e7 !important',
                boxShadow: 'none !important',
                background: 'white !important',
                color: '#7e7e7e !important',
                height: '1.4375em !important',
              }}
            />
          </Stack>
        </Grid>
      </Grid>

      {loadingData && (
        <Box sx={{ alignSelf: 'center', textAlign: 'center' }}>
          <CircularProgress />
        </Box>
      )}

      {!loadingData && trainingData.length < 1 && (
        <Paper variant="outlined" sx={{ padding: '1rem' }}>
          <Stack
            direction="row"
            sx={{
              display: 'flex',
              gap: '1rem',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Typography variant="h6">No training programs found.</Typography>
            <AppPrimaryButton
              title="Create a new program"
              onClick={() => {
                navigation('/training-programs/training');
              }}
            />
          </Stack>
        </Paper>
      )}

      <Box>
        <Grid container spacing={5}>
          {!loadingData &&
            trainingData &&
            trainingData.map((data: any, index: number) => {
              const program = data.program_data;
              return (
                <Grid
                  item
                  sm={6}
                  xs={12}
                  key={index}
                  sx={{
                    display: 'flex',
                  }}
                >
                  <Paper
                    sx={{
                      padding: '10px',
                      flex: 1,
                      display: 'flex',
                      flexDirection: 'column',
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                      }}
                    >
                      <Box>
                        <Typography sx={{ fontSize: '20px', fontWeight: 600 }}>
                          {program.title}
                        </Typography>
                        <Typography
                          sx={{ fontSize: '15px', marginTop: '10px' }}
                        >
                          {program.description}
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: 'flex',
                          gap: '10px',
                          justifyContent: 'center',
                        }}
                      >
                        <Chip
                          // label={data?.isActive ? 'Active' : data?.status}
                          label={data.program_data.status}
                          sx={{ background: '#06362B', color: 'white' }}
                          size="small"
                        />
                        {orgACLConfig.training?.includes(
                          'training.trainingPrograms.delete'
                        ) && (
                          <Box
                            sx={{ cursor: 'pointer' }}
                            onClick={() => setDialogDelete(data._id)}
                          >
                            <DeleteQuiz />
                          </Box>
                        )}
                      </Box>
                    </Box>

                    <Box sx={{ marginTop: '30px' }}>
                      <Typography
                        sx={{
                          fontSize: '16px',
                          fontWeight: 600,
                        }}
                      >
                        AI RMF Domains:
                      </Typography>
                      <Box
                        sx={{
                          marginTop: '5px',
                          display: 'flex',
                          gap: '5px',
                          flexWrap: 'wrap',
                        }}
                      >
                        {program.ai_rmf_domains &&
                          program.ai_rmf_domains.map(
                            (data: any, index: number) => (
                              <Chip
                                label={data}
                                sx={() => {
                                  const { bg, text } =
                                    getChipColorByIndex(index);
                                  return {
                                    background: bg,
                                    color: text,
                                  };
                                }}
                                size="small"
                              />
                            )
                          )}
                      </Box>
                    </Box>

                    <Box sx={{ marginTop: '30px' }}>
                      <Typography
                        sx={{
                          fontSize: '16px',
                          fontWeight: 600,
                        }}
                      >
                        Target Roles:
                      </Typography>
                      <Box
                        sx={{
                          marginTop: '5px',
                          display: 'flex',
                          gap: '5px',
                          flexWrap: 'wrap',
                          paddingBottom: '20px',
                          borderBottom: '1px solid #D1F27A',
                        }}
                      >
                        {program.target_roles &&
                          program.target_roles.map(
                            (data: any, index: number) => (
                              <Chip
                                label={data}
                                sx={() => {
                                  const { bg, text } =
                                    getChipColorByIndex(index);
                                  return {
                                    background: bg,
                                    color: text,
                                  };
                                }}
                                size="small"
                              />
                            )
                          )}
                      </Box>

                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          margin: '10px 0 30px 0',
                        }}
                      >
                        <Typography sx={{ fontSize: '14px', color: '#7E7E7E' }}>
                          {data.program_data.duration_minutes} minutes •{' '}
                          {data.program_data?.format || 'Online'}
                        </Typography>
                        <Typography sx={{ fontSize: '14px', color: '#7E7E7E' }}>
                          {data.assignmentCount} assignments • 0% complete
                        </Typography>
                      </Box>
                    </Box>

                    <Box sx={{ display: 'flex', gap: '1rem' }}>
                      {orgACLConfig.training?.includes(
                        'training.trainingPrograms.view'
                      ) && (
                        <AppPrimaryButton
                          title="View Details"
                          onClick={() => {
                            navigation(`/training-programs/view/${data._id}`);
                          }}
                          startIcon={<View />}
                          sx={{
                            backgroundColor: '#d1f27a !important',
                            color: '#052921 !important',
                          }}
                        />
                      )}
                      {orgACLConfig.training?.includes(
                        'training.trainingPrograms.edit'
                      ) && (
                        <AppPrimaryButton
                          title="Edit"
                          onClick={() => {
                            navigation(`/training-programs/edit/${data._id}`);
                          }}
                          startIcon={<Edit />}
                        />
                      )}
                    </Box>
                  </Paper>
                </Grid>
              );
            })}
        </Grid>
      </Box>
    </Stack>
  );
};

const TrainingProgramsList: React.FC<TrainingProgramsProps> = (props) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const {
    programs,
    trainingData,
    loadingData,
    handleUpdateList,
    debouncSearch,
    handleStatusChange,
    handleDomainChange,
    handleClearFilter,
  } = props;

  console.log(programs);
  const programsPagination = useSelector(
    (state: IAppState) => state.paginationState.programs
  );

  const [dialogDelete, setDialogDelete] = useState<any>(null);
  const deleteTrainingProgram = (id: any): void => {
    TrainingPorgramsService.deleteTrainingProgram(id)
      .then(() => {
        Toast.showSuccessMessage('Training program deleted successfully.');
        handleUpdateList();
        setDialogDelete(null);
      })
      .catch((error) => {
        Utils.handleErrorResponse(error);
      });
  };

  return (
    <Box className="training-program-wrapper">
      <Formik
        initialValues={{
          'search-programs': programsPagination.search,
          status: programsPagination.status,
          domains: programsPagination.domain,
        }}
        enableReinitialize
        onSubmit={() => console.log('searchprograms')}
      >
        <TrainingProgramListComponent
          loadingData={loadingData}
          trainingData={trainingData}
          setDialogDelete={setDialogDelete}
          debouncSearch={debouncSearch}
          handleStatusChange={handleStatusChange}
          handleDomainChange={handleDomainChange}
          handleClearFilter={handleClearFilter}
        />
      </Formik>

      <ConfirmDialog
        title="Delete Training Program"
        subTitle="Are you sure to delete the training program?"
        showConfirm={dialogDelete}
        cancelTitle="Close"
        successTitle="Delete"
        onSuccess={() => {
          setDialogDelete(false);
          deleteTrainingProgram(dialogDelete);
        }}
        onCancel={() => setDialogDelete(false)}
        onCloseDialog={() => setDialogDelete(false)}
      />
    </Box>
  );
};

export default TrainingProgramsList;
